import React from 'react';
import { TableBody } from 'material-ui/Table';
import DataConsumer from './DataConsumer';

const GridBody = ({ className, rowComponent: RowComponent, ...rowProps }) => {
    return (
        <TableBody className={className}>
            <DataConsumer>
                {({ keys = [] }) =>
                    keys.map(key => <RowComponent key={key} rowId={key} {...rowProps} />)
                }
            </DataConsumer>
        </TableBody>
    );
};

export default GridBody;
